import { List, Waveform, X } from '@phosphor-icons/react'
import { BRAND, DEMO_PHONE, DEMO_PHONE_LABEL, SIGNUP_CTA } from '@/landing/content'
import { needsConsent, openConsentSettings } from '@/lib/analytics'
import { FEATURE_PAGES } from './features'
import { INDUSTRY_PAGES } from './industries'
import { findSitePage } from './pages'

/** Main sections of the site. A link shows up once its page exists. */
const NAV = [
  { href: '/dlya', label: 'Галузі' },
  { href: '/funktsii', label: 'Можливості' },
  { href: '/tsiny', label: 'Ціни' },
  { href: '/faq', label: 'Питання' },
  { href: '/blog', label: 'Блог' },
]

const exists = (href: string) => Boolean(findSitePage(href))

export function SiteHeader() {
  const nav = NAV.filter((n) => exists(n.href))
  return (
    <header className="lp-nav">
      <div className="lp-wrap lp-nav-inner">
        <a href="/" className="lp-brand" aria-label={`${BRAND}, головна`}>
          <span className="lp-brand-mark"><Waveform size={18} weight="bold" /></span>
          {BRAND}
        </a>
        <nav className="lp-nav-links" aria-label="Розділи">
          {nav.map((n) => <a key={n.href} href={n.href}>{n.label}</a>)}
        </nav>
        <div className="lp-nav-cta">
          <a href="/login" className="lp-link-quiet">Увійти</a>
          <a href="/register" className="lp-btn lp-btn-primary lp-btn-sm">{SIGNUP_CTA}</a>
          {/* Narrow screens: the same links behind a native disclosure, so it
              opens before (and without) JavaScript. */}
          <details className="lp-menu">
            <summary aria-label="Меню">
              <List size={22} weight="bold" className="lp-menu-open" />
              <X size={22} weight="bold" className="lp-menu-close" />
            </summary>
            <nav className="lp-menu-panel" aria-label="Меню">
              <a href="/register" className="lp-menu-signup">{SIGNUP_CTA}</a>
              {nav.map((n) => <a key={n.href} href={n.href}>{n.label}</a>)}
              <a href="/#pilot">Безкоштовний пілот</a>
              <a href="/login">Увійти в кабінет</a>
            </nav>
          </details>
        </div>
      </div>
    </header>
  )
}

export function SiteFooter() {
  const company = [
    ...NAV.filter((n) => n.href === '/tsiny' || n.href === '/faq' || n.href === '/blog'),
    { href: '/#pilot', label: 'Безкоштовний пілот' },
    { href: '/login', label: 'Увійти в кабінет' },
    { href: '/privacy', label: 'Конфіденційність' },
    { href: '/terms', label: 'Умови' },
  ].filter((n) => n.href.startsWith('/#') || exists(n.href) || n.href === '/login')
  const groups = [
    { title: 'Галузі', links: INDUSTRY_PAGES.filter((p) => exists(p.path)).map((p) => ({ href: p.path, label: p.title })) },
    { title: 'Можливості', links: FEATURE_PAGES.filter((p) => exists(p.path)).map((p) => ({ href: p.path, label: p.title })) },
    { title: BRAND, links: company },
  ].filter((g) => g.links.length > 0)

  return (
    <footer className="lp-footer">
      <div className="lp-wrap">
        <div className="lp-footer-grid">
          <div className="lp-footer-about">
            <a href="/" className="lp-brand">
              <span className="lp-brand-mark"><Waveform size={16} weight="bold" /></span>
              {BRAND}
            </a>
            <p className="lp-muted">AI-адміністратор, який приймає дзвінки 24/7 українською.</p>
            <p>Демо-лінія: <a href={`tel:${DEMO_PHONE}`}>{DEMO_PHONE_LABEL}</a></p>
          </div>
          {groups.map((g) => (
            <nav key={g.title} aria-label={g.title}>
              <p className="lp-footer-title">{g.title}</p>
              <ul>
                {g.links.map((l) => <li key={l.href}><a href={l.href}>{l.label}</a></li>)}
              </ul>
            </nav>
          ))}
        </div>
        <div className="lp-footer-copy lp-muted">
          <span suppressHydrationWarning>© {new Date().getFullYear()} {BRAND}</span>
          {needsConsent && (
            <button type="button" className="lp-footer-cookie" onClick={openConsentSettings}>
              Налаштування cookie
            </button>
          )}
        </div>
      </div>
    </footer>
  )
}
